import { Icon } from '@cotera/client/app/components/ui';
import { useOpenCommandPalette } from '@cotera/client/v0/actions/command-palette';
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@cotera/client/v0/components/ui/sidebar';
import { displayShortcut } from '../../lib/utils';
import { UserMenu } from './user';
import { TabLink } from '../../tab-manager';
import { useOpenToolsModal } from '../tool-connections/tool-connections-dialog';

export function Header() {
  const openCmdk = useOpenCommandPalette();
  const openToolsModal = useOpenToolsModal();

  return (
    <SidebarMenu>
      <UserMenu />
      <SidebarMenuItem>
        <SidebarMenuButton
          asChild
          onClick={openCmdk}
          tooltip={`Search, run commands, and talk to AI ${displayShortcut([
            'ctrl',
            'k',
          ])}`}
        >
          <div className="cursor-pointer">
            <Icon icon="search" />
            <span>Search</span>
          </div>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton asChild>
          <TabLink to={'/home'}>
            <Icon icon="home" />
            <span>Home</span>
          </TabLink>
        </SidebarMenuButton>
      </SidebarMenuItem>
      <SidebarMenuItem>
        <SidebarMenuButton className="cursor-pointer" onClick={openToolsModal}>
          <Icon icon="wrench" />
          <span>Tools</span>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
